
import { defineComponent } from 'vue'
import Card from '@/components/Card.vue'
import HeadingWithMargin from '@/components/HeadingWithMargin.vue'
import LoanDetailsBreakdown from '@/components/LoanDetailsBreakdown.vue'
import LoanDetailsTotalInterest from '@/components/LoanDetailsTotalInterest.vue'
import LoanDetailsHeading from '@/components/LoanDetailsHeading.vue'
import LoanDetailsOptions from '@/components/LoanDetailsOptions.vue'
import { useRoute } from 'vue-router'
import useLoan from '@/composables/useLoan'
import useCalculator from '@/composables/useCalculator'

export default defineComponent({
  components: {
    Card,
    LoanDetailsHeading,
    HeadingWithMargin,
    LoanDetailsTotalInterest,
    LoanDetailsBreakdown,
    LoanDetailsOptions
  },

  setup () {
    const { editLoan } = useCalculator()
    const { params } = useRoute()
    const id = params.id.toString()
    const loan = useLoan(id)
    const edit = () => editLoan(id)

    return {
      edit,
      ...loan
    }
  }
})
